import { persistReducer, persistStore } from 'redux-persist'
import localforage from 'loankeeper-common/store/localforage'

const isProduction = process.env.NODE_ENV === 'production'

const config = {
  version: 1,
  key: 'root',
  storage: localforage,
  //segment of the store which is saved in indexedDB
  whitelist: ['persisted'],
  stateReconciler: (inboundState, _originalState, reducedState) => ({
    ...reducedState,
    ...inboundState,
  }),
  debug: !isProduction,
}

export const makePersistantReducer = (reducer) => persistReducer(config, reducer)

export function makePersistor(store) {
  const persistor = persistStore(store)

  return new Promise((resolve) => {
    let isReady = false

    function handlePersistorState() {
      const { bootstrapped } = persistor.getState()

      if (!isReady && bootstrapped) {
        isReady = true
        resolve(undefined)
      }
    }

    persistor.subscribe(handlePersistorState)
  })
}
